export * from './baMenuItem.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baMenu/components/baMenuItem/index.ts